import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Container from "../../common/Container";
import Banner from "../components/Banner";
import Menu from "../components/Menu";
import Sidebar from "../components/DepartmentSidebar";
import Clients from "../components/Clients";
import SeoTexts from "../components/SeoTexts";
import BreadcrumbsContainer from "../components/BreadcrumbsContainer";
import Products from "../components/DepartmentProducts";
import Search from "../components/Search";
import {onPlatformSelector} from "../ducks/onPlatform";
import classnames from "classnames";
import VTBBanner from "../components/VTBBanner";

import styles from "./products.module.scss";

function Department({onPlatform}) {
  return (
    <Grid
      container
      className={classnames(styles.root, {
        [styles.rootVTB]: onPlatform
      })}
    >
      {onPlatform !== `vtb` && (
        <Grid item xs={12} className={styles.breadcrumbs}>
          <Container>
            <BreadcrumbsContainer />
          </Container>
        </Grid>
      )}
      <Grid item xs={12} className={styles.banner}>
        {onPlatform !== `vtb` ? <Banner /> : <VTBBanner />}
      </Grid>
      <Grid item xs={12} className={styles.navigation}>
        <Menu />
      </Grid>
      <Grid item xs={12} className={styles.content}>
        <Container>
          <Grid container>
            <Grid item xs={12} lg={3}>
              <Sidebar />
            </Grid>
            <Grid item xs={12} lg={9}>
              <Products />
              <Hidden mdDown>
                <Search />
              </Hidden>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {onPlatform !== `vtb` && (
        <Grid item xs={12} className={styles.b2b}>
          <Clients />
        </Grid>
      )}
      <Grid item xs={12} className={styles.beforeFooterText}>
        <Container>
          <SeoTexts />
        </Container>
      </Grid>
    </Grid>
  );
}

Department.propTypes = {
  onPlatform: PropTypes.string
};

const mapStateToProps = (state) => ({
  onPlatform: onPlatformSelector(state)
});

export default connect(mapStateToProps)(Department);
